import React from 'react';
import AppBar from '@mui/material/AppBar';
import { Divider, Link, Stack, Toolbar, Typography } from '@mui/material';
import { configService } from '../../service';

const Footer = () => {
    return (
        <AppBar color="primary" position="static">
            <Toolbar>
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} fullWidth style={{ width: '100%' }}>
                    <Stack direction={'row'}>
                        <Link without="true" rel="noopener noreferrer" target="_blank" color="#FFFFFF">
                            Terms of Use
                        </Link>
                        <Divider sx={{ border: '1px solid #da1f33', margin: '0 12px' }} orientation="vertical" flexItem />
                        <Typography>Copyright © 2016-2023 by ABS. All rights reserved.</Typography>
                    </Stack>
                    <Typography>v{configService.appConfig.lastUpdate}</Typography>
                </Stack>
            </Toolbar>
        </AppBar>
    );
};

export default Footer;
